// Neena color palette
export const neena = {
  red: {
    50: "#fdf5ef",
    100: "#fbe8d9",
    200: "#f5ceb3",
    300: "#efad82",
    400: "#e78150",
    500: "#e78150",
    600: "#da4c24",
    700: "#af371f",
    800: "#8c2e20",
    900: "#71281d",
    950: "#3d120d",
  },
  yellow: {
    50: "#FFFBF2",
    100: "#FFF4DD",
    200: "#FFE6B4",
    300: "#FFCB63",
    400: "#FFBD3A",
    600: "#FFAA02",
    700: "#C98600",
    800: "#916000",
    900: "#593B00",
    950: "#3D2800",
  },
  darkgreen: {
    500: "#1B3936",
  },
  lightgreen: {
    500: "#c0cfcd",
  },
  grey: {
    500: "#EAE6D9",
  },
};
